import { IconAlertChecked, IconAlertCrossed, IconAlertInfo, IconAlertQuestion, IconAlertWarning, } from '@doppio/icons';
import { Text, useDripsyTheme, View } from 'dripsy';
import * as React from 'react';
const TEST_ID = 'doppio-alert';
const Alert = React.forwardRef(({ children, id, shouldAnnounce = false, variant = 'info', ...props }, forwardedRef) => {
    const mapIconToVariant = {
        warning: IconAlertWarning,
        question: IconAlertQuestion,
        error: IconAlertCrossed,
        success: IconAlertChecked,
        info: IconAlertInfo,
    };
    const Icon = mapIconToVariant[variant];
    const { theme } = useDripsyTheme();
    const { color } = theme.alerts[variant];
    return (React.createElement(View, { ref: forwardedRef, variant: `alerts.${variant}`, sx: {
            flexDirection: 'row',
            width: '100%',
            paddingTop: '$2',
            paddingBottom: '$2',
            paddingLeft: '$3',
            paddingRight: '$3',
        }, nativeID: id, testID: TEST_ID, accessibilityRole: shouldAnnounce ? 'alert' : undefined, ...props },
        React.createElement(View, { sx: {
                width: '$6',
                height: '$6',
                marginRight: '$2',
            }, accessibilityHidden: true },
            React.createElement(Icon, { color: color })),
        React.createElement(Text, { sx: { cursor: 'default', color: 'text', lineHeight: '$3', alignSelf: 'center' }, variant: "paragraphMedium" }, children)));
});
const AlertCompound = Object.assign({}, Alert, { displayName: 'Alert', testID: TEST_ID });
export { AlertCompound as Alert };
//# sourceMappingURL=Alert.js.map